import { Config } from '../_config'
import { Domain } from './Domain'

export class WindowDomain extends Domain {
  static create({ config }: { config: Config }) {
    return new WindowDomain(config)
  }

  constructor(private config: Config) {
    super()
  }

  url() {
    return new URL(window.location.href)
  }
}
